import {PlainTextOrHtml, intlShape, locationContainer} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';

import styles from './ReportLinkFormatter.less';
import {DocumentLink} from 'src/js/containers/file/components/DocumentLink';
import baseReportLinkFormatterParams from 'src/js/lib/raw_rendering/base_report_link_formatter_params';

class ReportLinkFormatter extends React.PureComponent {
  render() {
    const {intl} = this.props;
    const {filterName, label, link, route, searchParams, titleText} =
      baseReportLinkFormatterParams(this.props, {intl});

    return (
      <div className={styles.dlReportLink}>
        {filterName && route && link && searchParams ? (
          <DocumentLink
            documentDetailRoute={route}
            titleText={titleText}
            searchParams={searchParams}
            suppressPadding
          >
            <PlainTextOrHtml text={label} showHtml />
          </DocumentLink>
        ) : (
          // link value is empty - show only label
          <PlainTextOrHtml text={label} showHtml />
        )}
      </div>
    );
  }
}

ReportLinkFormatter.displayName = 'ReportLinkFormatter';

/* eslint-disable react/no-unused-prop-types */
ReportLinkFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ReportLinkFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(
  connect((state) => ({
    queryParameters:
      state[locationContainer.LOCATION_REDUCER_STATE_ID].parameters,
  }))(ReportLinkFormatter)
);
